/**
 * `Spinner` - the one indeterminate-progress glyph.
 *
 * Always decorative: it never carries an accessible name, because the
 * component around it (`LoadingPanel`, `MaskedField`) owns the announcement.
 * A spinner that announces itself alongside a "Loading member" live region
 * says the same thing twice.
 *
 * Honours `prefers-reduced-motion` by holding still - the arc alone still
 * reads as a busy indicator, and the surrounding live region carries the
 * meaning for anyone who cannot see it.
 */
export interface SpinnerProps {
  /** Edge length in px. Defaults to 14, which sits on a 20px line. */
  readonly size?: number
  readonly className?: string
}

export function Spinner({ size = 14, className = '' }: SpinnerProps): JSX.Element {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      aria-hidden="true"
      className={`flex-none animate-spin motion-reduce:animate-none ${className}`}
    >
      <circle cx="12" cy="12" r="9" opacity="0.25" />
      <path d="M21 12a9 9 0 0 0-9-9" strokeLinecap="round" />
    </svg>
  )
}
